// extracted by css-extract-rspack-plugin
export default {"container":"container-XylWGq","flag":"flag-peNrU2"};